import { render, staticRenderFns } from "./SvgSpriteAndIconFont.vue?vue&type=template&id=19cfd9e8&scoped=true&"
import script from "./SvgSpriteAndIconFont.vue?vue&type=script&lang=js&"
export * from "./SvgSpriteAndIconFont.vue?vue&type=script&lang=js&"
import style0 from "./SvgSpriteAndIconFont.vue?vue&type=style&index=0&id=19cfd9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfd9e8",
  null
  
)

export default component.exports